import { Helmet } from 'react-helmet-async'
import PageWrapper from './PageWrapper'

function More() {
  return (
    <PageWrapper forceReadableWidth>
      <Helmet>
        <title>More</title>
      </Helmet>
      <h1>More</h1>
      <h2>Thanks</h2>
      <p>Thanks for visiting. I hope you enjoyed your stay.</p>
      <h2>Contact</h2>
      <p>
        I'm most responsive through Discord DMs, you can
        {' '}
        <a
          target="_blank"
          href="https://discord.com/users/819191621676695563"
          rel="noreferrer"
        >
          DM me
        </a>
        {' '}
        on Discord.
      </p>
      <p>
        For any inquiries or assistance, please don't hesitate to contact me
        {' '}
        <a
          target="_blank"
          href="https://mail.google.com/mail/u/0/?fs=1&to=ruhanrouf17@gmail.com&tf=cm"
          rel="noreferrer"
        >
          RuhanRouf17@gmail.com
        </a>
        .
      </p>

      <h2>Other</h2>
      <ul>
        <li>
          <a
            style={{
              display: 'inline-block',
              margin: '4px 0px',
            }}
            target="_blank"
            href="https://www.linkedin.com/in/ruhan-rouf"
            rel="noreferrer"
          >
            /linkedin
          </a>
        </li>
        <li>
          <a
            style={{
              display: 'inline-block',
              margin: '4px 0px',
            }}
            target="_blank"
            href="https://www.facebook.com/ruhan.rouf.1/"
            rel="noreferrer"
          >
            /facebook
          </a>
        </li>
        <li>
          <a
            style={{
              display: 'inline-block',
              margin: '4px 0px',
            }}
            target="_blank"
            href="https://codepen.io/Kami-Ru"
            rel="noreferrer"
          >
            /codepen
          </a>
        </li>
        <li>
          <a
            style={{
              display: 'inline-block',
              margin: '4px 0px',
            }}
            target="_blank"
            href="https://leetcode.com/u/Kamiru17"
            rel="noreferrer"
          >
            /leetcode
          </a>
        </li>
        <li>
          <a
            style={{
              display: 'inline-block',
              margin: '4px 0px',
            }}
            target="_blank"
            href="https://blog.ruhann.me"
            rel="noreferrer"
          >
            /blogs
          </a>
        </li>
      </ul>
    </PageWrapper>
  )
}

export default More
